import { JsonapiError } from 'spraypaint';
import { ErrorResponse } from '../../types';

// 👇 matches /data/ in the beginning of the string
const reg = /^\/data\/attributes\//;

export function getJsonapiErrors(
  error: ErrorResponse,
): JsonapiError[] | undefined {
  if (typeof error !== 'string' && error?.response) {
    return error.response.errors;
  }
  return undefined;
}

export function getJsonapiErrorsCodes(
  error: ErrorResponse,
): string[] | undefined {
  const errors = getJsonapiErrors(error);
  if (errors && errors.length) {
    return errors.map(e => e.code || '');
  }
  return undefined;
}

export function getErrorMessages(error: ErrorResponse): string[] {
  if (typeof error === 'string') {
    return error.split(/\r\n|\n/);
  }
  const errors = getJsonapiErrors(error);
  if (errors && errors.length) {
    const list = errors.map((e: JsonapiError) => {
      const { detail = '', code = '' } = e;
      const { pointer, parameter } = e.source || {};
      const parts: string[] = [];
      // 👇 generate a string like: "[$code: ][$pointer|$parameter - ]$detail"
      if (detail) parts.push(`${detail}`);
      if (pointer || parameter) {
        const sanitized = (pointer || parameter || '').replace(reg, '');
        parts.unshift(`${sanitized}${parts.length ? ' - ' : ''}`);
      }
      if (code) parts.unshift(`${code}${parts.length ? ': ' : ''}`);
      return parts.join('');
    });
    return list;
  }
  return [error.message || error.toString()];
}

export function getErrorMessage(error: ErrorResponse): string {
  return getErrorMessages(error).join('\n');
}
